import Disclaimer from '@components/Disclaimer'
import type { ParentProps } from 'solid-js'
import { Grid } from 'styled-system/jsx'
import List from './List'
import Single from './Single'

function Container(props: ParentProps) {
  return <Grid gap='0' gridTemplateRows='auto 1fr auto'>
    {props.children}
    <Disclaimer />
  </Grid>
}

const routes = [
  {
    path: '/recordings',
    component: Container,
    children: [
      {
        path: '/',
        component: List,
      },
      {
        path: '/:id',
        component: Single,
      },
    ],
  },
]

export default routes
